function capacityLabel(status?: string | null) {
  switch (status) {
    case "OVER_LIMIT":
      return "Over Limit"
    case "NEAR_LIMIT":
      return "Near Limit"
    default:
      return "Available"
  }
}

function capacityTone(status?: string | null) {
  switch (status) {
    case "OVER_LIMIT":
      return "bg-red-500"
    case "NEAR_LIMIT":
      return "bg-amber-500"
    default:
      return "bg-emerald-500"
  }
}

export function CapacityGauge({
  assignedClients,
  remainingCapacity,
  status,
}: {
  assignedClients: number
  remainingCapacity: number
  status?: string | null
}) {
  const maxClients = Math.max(assignedClients, assignedClients + Math.max(remainingCapacity, 0), 1)
  const ratio = Math.min(1, assignedClients / maxClients)

  return (
    <div className="space-y-1">
      <div className="h-2 overflow-hidden rounded-full bg-slate-100">
        <div
          className={`h-full rounded-full ${capacityTone(status)}`}
          style={{ width: `${Math.max(8, ratio * 100)}%` }}
        />
      </div>
      <div className="flex items-center justify-between text-[11px]">
        <span className="font-medium text-slate-700">{capacityLabel(status)}</span>
        <span className="text-slate-500">{remainingCapacity}</span>
      </div>
    </div>
  )
}
